export const mapStyles = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"administrative.country","elementType":"geometry.fill","stylers":[{"lightness":"33"}]},{"featureType":"administrative.locality","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"lightness":"46"}]},{"featureType":"administrative.locality","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"administrative.neighborhood","elementType":"labels.text.fill","stylers":[{"lightness":"22"}]},{"featureType":"administrative.neighborhood","elementType":"labels.text.stroke","stylers":[{"lightness":"-15"},{"gamma":"0.00"},{"visibility":"off"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"lightness":"10"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":21}]},{"featureType":"poi","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"poi.attraction","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":17}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"lightness":"-9"}]}]

export const ctaStyles = [ {
    "featureType":"all",
    "elementType":"labels.text.fill",
    "stylers":[ {
        "visibility": "off"
    }
    ]
},
{
    "featureType":"all",
    "elementType":"labels.text.stroke",
    "stylers":[ {
        "visibility": "off"
    }
    ,
    {
        "color": "#000000"
    }
    ,
    {
        "lightness": 16
    }
    ]
}

,
{
    "featureType":"all",
    "elementType":"labels.icon",
    "stylers":[ {
        "visibility": "off"
    }
    ]
}

,
{
    "featureType":"administrative",
    "elementType":"geometry.fill",
    "stylers":[ {
        "visibility": "off"
    },{
        "color": "#000000"
    }
    ,
    {
        "lightness": 20
    }
    ]
}

,
{
    "featureType":"administrative",
    "elementType":"geometry.stroke",
    "stylers":[ {
        "visibility": "off"
    },{
        "color": "#000000"
    }
    ,
    {
        "lightness": 17
    }
    ,
    {
        "weight": 1.2
    }
    ]
}

,
{
    "featureType":"administrative.country",
    "elementType":"geometry.fill",
    "stylers":[ {
        "lightness": "33"
    }
    ]
}

,
{
    "featureType":"administrative.locality",
    "elementType":"labels.text",
    "stylers":[ {
        "visibility": "off"
    }
    ]
}

,
{
    "featureType":"administrative.locality",
    "elementType":"labels.text.fill",
    "stylers":[ {
        "lightness": "46"
    }
    ]
}

,
{
    "featureType":"administrative.locality",
    "elementType":"labels.text.stroke",
    "stylers":[ {
        "visibility": "off"
    }
    ]
}

,
{
    "featureType":"administrative.neighborhood",
    "elementType":"labels.text.fill",
    "stylers":[ {
        "lightness": "22"
    }
    ]
}

,
{
    "featureType":"administrative.neighborhood",
    "elementType":"labels.text.stroke",
    "stylers":[ {
        "lightness": "-15"
    }
    ,
    {
        "gamma": "0.00"
    }
    ,
    {
        "visibility": "off"
    }
    ]
}

,
{
    "featureType":"administrative.land_parcel",
    "elementType":"labels.text",
    "stylers":[ {
        "visibility": "off"
    }
    ]
}

,
{
    "featureType":"landscape",
    "elementType":"all",
    "stylers":[ {
        "visibility": "on"
    }
    ]
}

,
{
    "featureType":"landscape",
    "elementType":"geometry",
    "stylers":[ {
        "color": "#000000"
    }
    ,
    {
        "lightness": 20
    }
    ]
}

,
{
    "featureType":"landscape",
    "elementType":"geometry.fill",
    "stylers":[ {
        "lightness": "10"
    }
    ]
}

,
{
    "featureType":"poi",
    "elementType":"geometry",
    "stylers":[ {
        "color": "#000000"
    }
    ,
    {
        "lightness": 21
    }
    ]
}

,
{
    "featureType":"poi",
    "elementType":"geometry.stroke",
    "stylers":[ {
        "visibility": "off"
    }
    ]
}

,
{
    "featureType":"poi",
    "elementType":"labels.text.stroke",
    "stylers":[ {
        "visibility": "off"
    }
    ]
}

,
{
    "featureType":"poi.attraction",
    "elementType":"all",
    "stylers":[ {
        "visibility": "off"
    }
    ]
}

,
{
    "featureType":"poi.business",
    "elementType":"all",
    "stylers":[ {
        "visibility": "off"
    }
    ]
}

,
{
    "featureType":"road",
    "elementType":"labels",
    "stylers":[ {
        "visibility": "off"
    }
    ]
}

,
{
    "featureType":"road.highway",
    "elementType":"all",
    "stylers":[ {
        "visibility": "off"
    }
    ]
}

,
{
    "featureType":"road.highway",
    "elementType":"geometry.fill",
    "stylers":[ {
        "color": "#000000"
    }
    ,
    {
        "lightness": 17
    }
    ]
}

,
{
    "featureType":"road.highway",
    "elementType":"geometry.stroke",
    "stylers":[ {
        "color": "#000000"
    }
    ,
    {
        "lightness": 29
    }
    ,
    {
        "weight": 0.2
    }
    ]
}

,
{
    "featureType":"road.arterial",
    "elementType":"geometry",
    "stylers":[ {
        "color": "#000000"
    }
    ,
    {
        "lightness": 18
    }
    ]
}

,
{
    "featureType":"road.local",
    "elementType":"geometry",
    "stylers":[ {
        "color": "#000000"
    }
    ,
    {
        "lightness": 16
    }
    ]
}

,
{
    "featureType":"transit",
    "elementType":"geometry",
    "stylers":[ {
        "color": "#000000"
    }
    ,
    {
        "lightness": 19
    }
    ]
}

,
{
    "featureType":"water",
    "elementType":"geometry",
    "stylers":[ {
        "color": "#000000"
    }
    ,
    {
        "lightness": 17
    }
    ]
}

,
{
    "featureType":"water",
    "elementType":"geometry.fill",
    "stylers":[ {
        "lightness": "-9"
    }
    ]
}

]

export default ctaStyles